function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { useCallback, useEffect } from 'react';
import { usePromiseFactory } from '@deephaven/react-hooks';

/**
 * Return type of `useSelectDistinctTable` hook.
 */

/**
 * Creates and subscribes to a `selectDistinct` derived table and unsubscribes
 * on unmount.
 * @param table The table to call `selectDistinct` on.
 * @param columnNames The list of column names to pass to `selectDistinct`.
 */
export default function useSelectDistinctTable(table) {
  for (var _len = arguments.length, columnNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    columnNames[_key - 1] = arguments[_key];
  }
  var selectDistinct = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    var _table$selectDistinct;
    return (_table$selectDistinct = table === null || table === void 0 ? void 0 : table.selectDistinct(table.findColumns(columnNames))) !== null && _table$selectDistinct !== void 0 ? _table$selectDistinct : null;
  }),
  // Disabling the exhaustive checks due to the spreading of `columnNames`
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [table, ...columnNames]);
  var _usePromiseFactory = usePromiseFactory(selectDistinct, []),
    distinctTable = _usePromiseFactory.data,
    error = _usePromiseFactory.error,
    isError = _usePromiseFactory.isError,
    isLoading = _usePromiseFactory.isLoading;
  useEffect(() => () => {
    distinctTable === null || distinctTable === void 0 || distinctTable.close();
  }, [distinctTable]);
  return {
    distinctTable,
    error,
    isError,
    isLoading
  };
}
//# sourceMappingURL=useSelectDistinctTable.js.map